import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import './UseLocation.scss'

class UseLocation extends PureComponent {
  render () {
    const scPanelClass = this.props.smallBtn ? '' : 'sc-panel'
    const btnClass = this.props.smallBtn ? 'uselocation-btn' : 'uselocation-btn-block'

    return (
      <div className={`sc-uselocation ${scPanelClass} js-only`}>
        <button className={btnClass} onClick={this.props.getLocationFromBrowser}>
          <span className='uselocation-icon' aria-hidden='true' />
          <span className='uselocation-text'>Use current location</span>
        </button>
      </div>
    )
  }
}

UseLocation.defaultProps = {
  smallBtn: false
}

UseLocation.propTypes = {
  getLocationFromBrowser: PropTypes.func,
  smallBtn: PropTypes.bool
}

export default UseLocation



// WEBPACK FOOTER //
// ./src/components/UseLocation/UseLocation.jsx